import { ResourceBaseService } from "@/core/common/resource-base/resource-base.service";
import { ReportTemplateDto } from "@/core/features/report-templates/report-template.dto";
import { ApiHttpClient } from "@/core/common/http/api-http-client";
import { CreateReportTemplateDto } from "@/core/features/report-templates/create-report-template.dto";
import { UpdateReportTemplateDto } from "@/core/features/report-templates/update-report-template.dto";
import { ReportTemplateRecordDto } from "@/core/features/report-templates/report-template-record.dto";
import { plainToInstance } from "class-transformer";
import { HttpRequest } from "@/core/common/http/http-request";

export class ReportTemplatesResource extends ResourceBaseService<
  ReportTemplateDto,
  CreateReportTemplateDto,
  UpdateReportTemplateDto
> {
  protected EntityDto = ReportTemplateDto;
  protected CreateEntityDto = CreateReportTemplateDto;
  protected UpdateEntityDto = UpdateReportTemplateDto;
  protected RecordEntityDto = ReportTemplateRecordDto;

  constructor(protected readonly apiHttpClient: ApiHttpClient) {
    super(apiHttpClient, "/report-templates");
  }

  getByProjectId(projectId: string): Promise<ReportTemplateDto> {
    return this.apiHttpClient
      .request(
        HttpRequest.create({
          url: this.resourceUrl + "/by-project/" + projectId,
          method: "GET",
          auth: true,
        })
      )
      .then((result) => plainToInstance(ReportTemplateDto, result));
  }
}
